module.exports = __webpack_public_path__ + "img/Phone-Mockup.00f18d99.svg";